import React, { useEffect, useState } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import TextField from '@mui/material/TextField';
import { IAsyncDialogProps } from '../../components/AsyncDialog/AsyncDialog';

export function StatusReasonDialog(props: IAsyncDialogProps) {
  const [reason, setReason] = useState('');
  const [touched, setTouched] = useState(false);
  const [error, setError] = useState(true);

  const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setReason(event.target.value);
    setTouched(true);
  };

  const onOk = () => {
    if (!error && reason) {
      return props.onOk(reason);
    }

    return setTouched(true);
  };

  useEffect(() => {
    setReason('');
    setError(true);
    setTouched(false);
  }, [props.open]);

  useEffect(() => {
    setError(!reason);
  }, [reason]);

  return (
    <Dialog open={props.open} onClose={props.onClose}>
      <DialogTitle>What is the reason?</DialogTitle>
      <DialogContent>
        <DialogContentText>Type the reason of that status.</DialogContentText>
        <TextField
          margin="normal"
          id="reason"
          label="Reason"
          placeholder="Enter the reason"
          variant="standard"
          type="text"
          value={reason}
          onChange={onChange}
          error={touched && error}
          helperText="Reason is required"
          autoFocus
          fullWidth
          required
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={props.onClose}>Cancel</Button>
        <Button onClick={onOk}>Send</Button>
      </DialogActions>
    </Dialog>
  );
}
